import { type Maybe, ensure } from '@vrplatform/utils';
import type {
  accountType_enum,
  account_bool_exp,
  activeStatus_enum,
} from '@vrplatform/graphql';

export function whereAccounts({
  search,
  type,
  tenantId,
  status,
}: {
  tenantId: string;
  search?: Maybe<string>;
  type?: Maybe<accountType_enum>;
  status?: Maybe<activeStatus_enum>;
}) {
  return ensure<account_bool_exp>({
    type: type ? { _eq: type } : undefined,
    tenantId: { _eq: tenantId },
    status: status ? { _eq: status } : { _eq: 'active' },
    _or: search
      ? [
          {
            title: { _ilike: `%${search}%` },
          },
          {
            uniqueRef: { _ilike: `%${search}%` },
          },
        ]
      : undefined,
  });
}
